export enum UrgencyMessageType {
    FewTickets = 'fewTickets',
    SalesEndSoon = 'salesEndSoon',
}

export enum UrgencyHighlightType {
    EarlyBird = 'earlyBird',
    Popular = 'popular',
    New = 'new',
}

export type UrgencyMessages = {
    [key: string]: boolean;
};

export type UrgencyHighlights = {
    [key: string]: boolean;
};

export type UrgencySignalsProps =
    | {
          messages: UrgencyMessages;
          highlights: UrgencyHighlights;
      }
    | undefined;

export type EnabledUrgencySignals = {
    messages: { [key: string]: boolean | undefined };
    highlights: { [key: string]: boolean | undefined };
};
